export const checkValueToNotNull = (
  value,
  responseIfNull = "",
  responseIfOk = value,
) => {
  if (value === null || value === undefined || value === "") {
    return responseIfNull;
  }
  return responseIfOk;
};
